import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import LogoTop from "../assets/images/vbm_hort_logo.png";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import Badge from '@mui/material/Badge';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import { useNavigate, useLocation } from "react-router-dom";
import SupportIcon from '@mui/icons-material/ContactSupport';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import Link from '@mui/material/Link';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import FolderIcon from '@mui/icons-material/Folder';
import DeleteIcon from '@mui/icons-material/Delete';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAppSelector, useAppDispatch } from "../hooks";
import DialogLogout from "../components/ResponsiveAppBar";
import ConfirmDialog, { confirmDialog } from "../components/ConfirmDialog";

function generate(element: React.ReactElement) {
  return [0, 1, 2].map((value) =>
    React.cloneElement(element, {
      key: value,
    }),
  );
}

const Demo = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));



export default function PrimarySearchAppBar() {
  const userSelector = useAppSelector((state) => { return state.application.loggedInUser })
  const titleSelector = useAppSelector((state) => { return state.application.pageTitle });
  const backgroundSelector = useAppSelector((state) => { return state.application.backgroundPath })

  console.log("Selector", userSelector);
  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [open, setOpen] = React.useState(false);
  const [messagesOpen, setMessagesOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleMessagesOpen = () => {
    setMessagesOpen(true);
  };

  const handleMessagesClose = () => {
    setMessagesOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };



  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    React.useState<null | HTMLElement>(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';
  /* const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  ); */

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
          sx={{ mr: 4 }}
        >
          <Badge badgeContent={12} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <SupportIcon />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#FFF',
      },
    },
  });

  const navigate = useNavigate();

  const handleSubmit = () => console.log('Okay')

  return (
    <div>
      <ThemeProvider theme={darkTheme}>
        <Box sx={{ flexGrow: 1, borderBottom: '0px', paddingLeft: '0' }}>
          <AppBar position="static" sx={{ height: '60px', paddingLeft: '0', boxShadow: 12 }}>
            <Toolbar>
              {(window.history.state && window.history.state.idx > 0) &&
                <IconButton aria-label="Go Back" size="large" onClick={() => navigate(-1)} sx={{ marginRight: '25px' }}>
                  <ArrowCircleLeftOutlinedIcon sx={{ fontSize: 40, color: 'white' }} />
                </IconButton>
              }
              <img src={LogoTop} height='45px' />
              <Typography variant="h4" fontWeight={100} marginLeft={2} color='#666'>
                |
              </Typography>
              <Typography variant="h4" fontWeight={600} fontSize='24px' marginLeft={2}>
                {titleSelector}
              </Typography>
              <Box sx={{ flexGrow: 1 }} />
              <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                {/* <IconButton size="large" aria-label="show 4 new mails" color="inherit" sx={{ mr: 3 }} onClick={handleMessagesOpen}>
                <Badge badgeContent={4} color="error">
                  <MailIcon />
                </Badge>
              </IconButton> */}
                {userSelector != null &&
                  <Link href='/main/profile'>
                    <IconButton
                      size="large"
                      aria-label="account of current user"
                      aria-controls={menuId}
                      aria-haspopup="true"

                      color="inherit"
                      sx={{ mr: 3 }}
                    ><Typography fontWeight={500} sx={{ fontSize: 24, color: 'white' }} >
                        {userSelector?.fullName}
                      </Typography>
                      <AccountCircle />
                    </IconButton></Link>}

                <IconButton
                  size="large"
                  aria-label="support"
                  color="inherit"
                  onClick={handleClickOpen}
                >
                  <SupportIcon sx={{ fontSize: 40, color: 'white' }} />
                </IconButton>
                <IconButton
                  size="large"
                  aria-label="support"
                  color="inherit"
                  onClick={() => confirmDialog("Are you sure you want to logout?", handleSubmit)}
                >
                  <LogoutIcon sx={{ fontSize: 40, color: 'white' }} />
                </IconButton>
                <ConfirmDialog />
              </Box>


            </Toolbar>            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleClickOpen}
                color="inherit"
              >
                <SupportIcon />
              </IconButton>
            </Box>
          </AppBar>
          {renderMobileMenu}
          {/* {renderMenu} */}
        </Box>
      </ThemeProvider>



      <div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
            Need Support?
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography sx={{ mb: 3 }} variant="body2" gutterBottom>
              If you are having issues or have questions, please contact us below.
            </Typography>
            <Button size='large' fullWidth variant="contained" startIcon={<SmartphoneIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
              <Link href="tel:8003141797" underline="none" color="#FFF"><Typography variant='h6' fontWeight={700}>800-314-1797</Typography></Link>
            </Button>
            <Button size='large' fullWidth variant="contained" startIcon={<EmailIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
              <Link href="mailto:bobsmarket@idatp.com" underline="none">
                <Typography variant='h6' fontWeight={700} color="#FFF">support@idatp.com</Typography></Link>
            </Button>
          </DialogContent>
        </BootstrapDialog>
      </div>

      <div>
        <BootstrapDialog
          onClose={handleMessagesClose}
          aria-labelledby="customized-dialog-title"
          open={messagesOpen}
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleMessagesClose}>
            Messages & Notifications
          </BootstrapDialogTitle>
          <DialogContent dividers>

            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Messages" {...a11yProps(0)} />
                <Tab label="Notifications" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>

              <FormGroup row sx={{ p: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={dense}
                      onChange={(event) => setDense(event.target.checked)}
                    />
                  }
                  label="Enable dense"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={secondary}
                      onChange={(event) => setSecondary(event.target.checked)}
                    />
                  }
                  label="Enable secondary text"
                />
              </FormGroup>
              <Grid container spacing={0} padding={0} sx={{ p: 0 }}>
                <Grid item xs={12}>
                  <Demo>
                    <List dense={dense}>
                      {generate(
                        <ListItem
                          secondaryAction={
                            <IconButton edge="end" aria-label="delete">
                              <DeleteIcon />
                            </IconButton>
                          }
                        >
                          <ListItemAvatar>
                            <Avatar>
                              <FolderIcon />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary="Single-line item"
                            secondary={secondary ? 'Secondary text' : null}
                          />
                        </ListItem>,
                      )}
                    </List>
                  </Demo>
                </Grid>
              </Grid>

            </TabPanel>
            <TabPanel value={value} index={1}>

              <FormGroup row sx={{ p: 0 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={dense}
                      onChange={(event) => setDense(event.target.checked)}
                    />
                  }
                  label="Enable dense"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={secondary}
                      onChange={(event) => setSecondary(event.target.checked)}
                    />
                  }
                  label="Enable secondary text"
                />
              </FormGroup>
              <Grid container spacing={0} padding={0} sx={{ p: 0 }}>
                <Grid item xs={12}>
                  <Demo>
                    <List dense={dense}>
                      {generate(
                        <ListItem
                          secondaryAction={
                            <IconButton edge="end" aria-label="delete">
                              <DeleteIcon />
                            </IconButton>
                          }
                        >
                          <ListItemAvatar>
                            <Avatar>
                              <FolderIcon />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary="Single-line item"
                            secondary={secondary ? 'Secondary text' : null}
                          />
                        </ListItem>,
                      )}
                    </List>
                  </Demo>
                </Grid>
              </Grid>
            </TabPanel>
          </DialogContent>
        </BootstrapDialog>
      </div>
    </div>


  );
}
